"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeetingDocumentMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const meeting_entity_1 = require("./meeting.entity");
const file_upload_entity_1 = require("./file-upload.entity");
const look_up_entity_1 = require("./look-up.entity");
let MeetingDocumentMap = class MeetingDocumentMap {
    constructor(meetingId, documentId, documentTypeLid) {
        this.meetingId = meetingId;
        this.documentId = documentId;
        this.documentTypeLid = documentTypeLid;
    }
};
exports.MeetingDocumentMap = MeetingDocumentMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], MeetingDocumentMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "meeting_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], MeetingDocumentMap.prototype, "meetingId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], MeetingDocumentMap.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_type_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], MeetingDocumentMap.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => meeting_entity_1.Meeting, (meeting) => meeting.meetingDocs, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "meeting_id" }),
    tslib_1.__metadata("design:type", Object)
], MeetingDocumentMap.prototype, "meeting", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => file_upload_entity_1.FileUpload, (fileupload) => fileupload.meetingDocs, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "document_id" }),
    tslib_1.__metadata("design:type", Object)
], MeetingDocumentMap.prototype, "document", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "document_type_lid" }),
    tslib_1.__metadata("design:type", Object)
], MeetingDocumentMap.prototype, "documentType", void 0);
exports.MeetingDocumentMap = MeetingDocumentMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("meeting_document_map"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number])
], MeetingDocumentMap);
